import { FC, ReactNode } from 'react';

interface WorkflowCardProps {
  icon: ReactNode;
  title: string;
  description: string;
  onClick: () => void;
  disabled?: boolean;
}

export const WorkflowCard: FC<WorkflowCardProps> = ({
  icon,
  title,
  description,
  onClick,
  disabled = false,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      aria-disabled={disabled}
      className={`group relative w-[260px] bg-white rounded-lg border border-peach-1 text-left overflow-hidden
        transition-all duration-200 ease-out ${
          disabled
            ? 'cursor-not-allowed opacity-55'
            : 'cursor-pointer hover:shadow-workflow hover:-translate-y-0.5'
        }`}
    >
      <div className="p-6 flex flex-col gap-4">
        {/* Icon */}
        <div
          className={`w-12 h-12 rounded-xl flex items-center justify-center
          transition-colors duration-200 ${
            disabled
              ? 'bg-grey-light text-grey-medium'
              : 'bg-peach text-pif-green group-hover:bg-pif-green group-hover:text-white'
          }`}
        >
          {icon}
        </div>

        {/* Title */}
        <div className="text-xl font-bold text-grey-black leading-[24px] tracking-[0.1px]">{title}</div>

        {/* Description */}
        <div className="text-md font-regular text-grey-hover leading-[22px]">{description}</div>

        {/* Hover arrow */}
        {!disabled && (
          <div
            className="flex items-center gap-1.5 text-pif-green text-[13px] font-medium tracking-[0.5px] uppercase
          opacity-0 translate-x-[-4px] group-hover:opacity-100 group-hover:translate-x-0
          transition-all duration-200"
          >
            Start
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14" />
              <path d="m12 5 7 7-7 7" />
            </svg>
          </div>
        )}
      </div>
    </button>
  );
};
